import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Row, Col, Nav } from 'react-bootstrap';
import { TabContent } from './TabGroupContent';
export const SubTabLayout = ({ nav, tabs }) => {
    return (_jsx(_Fragment, { children: _jsxs(Col, { children: [_jsx(Row, { children: _jsx(Nav, Object.assign({ variant: 'underline', className: 'flex-row' }, { children: nav })) }), _jsx(Row, Object.assign({ className: 'mt-3' }, { children: _jsx(TabContent, { tabs: tabs }) }))] }) }));
};
